import {YStack} from "@chayka/ui";

interface BaseSlideProps {
  imageSrc: string;
  description: string;
}

export const BaseSlide: React.FC<BaseSlideProps> = ({imageSrc, description}) => {
  return (
    <YStack className="justify-between items-center flex-1 pt-12 h-full">
      <YStack className="gap-6 justify-center items-center flex-2">
        <img src={imageSrc} alt="Illustration" className="w-48 h-48 object-contain" />
        <div className="text-center text-sm text-secondary-text">{description}</div>
      </YStack>
    </YStack>
  );
};
